import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import "./Scrollbar.css";
import { get } from "../../../../utils/api";
const FacilityFilter = ({
  selectedEqupments = [],
  setSelectedEquipments,
  url,
  errors,
}) => {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    // Fetch all Facilities from the backend
    const fetchFacilities = async () => {
      try {
        const response = await get(url);
        // Extract unique Facility names from the user data
        console.log(response.data);
        const uniqueFacilities = [
          ...new Set(response.data.data.map((item) => item.brand)),
        ];
        setFacilities(uniqueFacilities);
        console.log("uniqueFacilities", uniqueFacilities);
      } catch (error) {
        console.error("Error fetching Facilities:", error);
      }
    };

    fetchFacilities();
  }, []);

  // const handleFacilityChange = (event) => {
  //   const selectedEqupments = event.target.value;
  //   if (event.target.checked) {
  //     // Add Facility to selected list
  //     setSelectedEquipments((prevSelected) => [
  //       ...prevSelected,
  //       selectedEqupments,
  //     ]);
  //   } else {
  //     // Remove Facility from selected list
  //     setSelectedEquipments((prevSelected) =>
  //       prevSelected.filter((Facility) => Facility !== selectedEqupments)
  //     );
  //   }
  // };

  const handleFacilityChange = (event) => {
    const selectedCountry = event.target.value;
 
    if (event.target.checked) {
      setSelectedEquipments([...selectedEqupments, selectedCountry]);
    } else {
      setSelectedEquipments(
        selectedEqupments.filter((country) => country !== selectedCountry)
      );
    }
  };
 

  return (
    // <Box sx={{m:"5%",mt:0}}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: 2,
        paddingBottom: "15%",
        height: "100%",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          // m:"10%"
        }}
      >
        Brand
      </Typography>
      <Box className="scrollable-container">
        {facilities.length > 0 ? (
          facilities.map((Brand, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={Brand}
                  checked={selectedEqupments?.includes(Brand)} // Ensure selectedEqupments is an array
                  onChange={handleFacilityChange}
                />
              }
              label={Brand}
            />
          ))
        ) : (
          <Typography>No Facilities found</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default FacilityFilter;
